import React, { PureComponent } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
class SlideIndicator extends PureComponent {
  render() {
    const {
      classes,
      onSlideChange,
      activeSlideIndex,
      slideCount
    } = this.props;
    const tabs = [];
    for (let i = 0; i < slideCount; i++) {
      tabs.push(/*#__PURE__*/React.createElement("div", {
        key: i,
        id: `hiwDot-${i + 1}`,
        classes: {
          root: classes.tabRoot
        }
      }));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, slideCount > 1 && tabs.map((t1, index) => /*#__PURE__*/React.createElement("div", {
      className: activeSlideIndex === index ? classes.activeIndicator : classes.tabRoot,
      key: t1.key,
      onClick: e => onSlideChange(e, index)
    })));
  }
}
const styles = theme => ({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    padding: "5px",
    listStyle: "none"
  },
  tabRoot: {
    minWidth: 0,
    margin: 5,
    backgroundColor: theme.palette.primary.light,
    height: 12,
    width: 12,
    borderRadius: "50%",
    minHeight: 12,
    //for IE11,
    padding: 0,
    "&:hover": {
      cursor: "pointer"
    }
  },
  activeIndicator: {
    backgroundColor: theme.palette.primary.dark,
    height: "12px",
    width: "12px",
    borderRadius: "50%",
    marginBottom: "5px",
    minHeight: 12,
    padding: 0,
    margin: 5
  }
});
export default withStyles(styles)(SlideIndicator);
SlideIndicator.propTypes = {
  classes: PropTypes.object.isRequired,
  slideCount: PropTypes.number.isRequired,
  activeSlideIndex: PropTypes.number.isRequired,
  onSlideChange: PropTypes.func.isRequired
};